import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useState } from 'react';
import { DATA_SUB_PROCESSOR_KEY, THIRD_PARTY_KEY } from '../../constants';
export const allFields = {
  name: '',
  link: '',
  thirdPartyCountries: [],
  purpose: ''
};
export const useThirdPartyEntityData = (onChange, thirdPartyDetails, dataSubProcessors) => {
  const [radioValue, setRadioValue] = useState(true);
  const [fields, setFields] = useState([_objectSpread({}, allFields)]);
  useEffect(() => {
    if (thirdPartyDetails) {
      setFields(thirdPartyDetails); // [{name: 'abc', link: ''}]
      setRadioValue(true);
    }
  }, [thirdPartyDetails]);
  useEffect(() => {
    if (dataSubProcessors) {
      setRadioValue(false);
    }
  }, [dataSubProcessors]);
  const addField = () => {
    onChange([...fields, _objectSpread({}, allFields)], THIRD_PARTY_KEY);
  };
  const removeField = index => {
    const newArray = [...fields];
    newArray.splice(index, 1);
    onChange(newArray, THIRD_PARTY_KEY);
  };
  const handleTextgroupChange = (value, key, index) => {
    const newFields = [...fields];
    newFields[index][key] = value;
    onChange(newFields, THIRD_PARTY_KEY);
  };
  const handleProcessorLinkChange = (value, key) => {
    onChange(value, key);
  };
  const handleRadioChange = value => {
    if (value === false) {
      setFields([_objectSpread({}, allFields)]);
      onChange(undefined, THIRD_PARTY_KEY);
    } else {
      handleProcessorLinkChange(undefined, DATA_SUB_PROCESSOR_KEY);
    }
    setRadioValue(value);
  };
  return {
    radioValue,
    fields,
    addField,
    removeField,
    handleTextgroupChange,
    handleProcessorLinkChange,
    handleRadioChange
  };
};